/* ============================================================
   Awaïnël - Reservation LP shared JS (page.reservation / page.reservation-form)
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  // Viewport height custom property, in case a full-height section is
  // added later. Only recompute on actual width changes (rotation),
  // not on every resize, so mobile address-bar show/hide never causes
  // a visible jump (see assets/main.js for the same fix on the TOP hero).
  var lastVhWidth = window.innerWidth;
  function setVh() {
    document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
  }
  setVh();
  window.addEventListener('resize', function () {
    if (window.innerWidth !== lastVhWidth) {
      lastVhWidth = window.innerWidth;
      setVh();
    }
  });

  // 予約ボタンエリア（sections/reservation-cta.liquid）のリンク先組み立て。
  // 今アクセスしている本人の preview_theme_id を引き継いだ上で、
  // 「ゲスト予約」「情報を保存して予約」どちらも同じ予約フォームへ直接
  // 遷移する（Shopifyログインは経由しない。理由は reservation-cta.liquid
  // のコメント参照）。黒ボタンの文言は常に「情報を保存して予約」で固定する
  // （前回情報の保存有無による出し分けはしない）。
  var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');

  function withPreviewThemeId(url) {
    if (!previewThemeId) return url;
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 'preview_theme_id=' + encodeURIComponent(previewThemeId);
  }

  document.querySelectorAll('[data-rsv-cta]').forEach(function (cta) {
    var formUrl = cta.getAttribute('data-form-url');
    if (!formUrl) return;
    var formTarget = withPreviewThemeId(formUrl);

    var guestLink = cta.querySelector('[data-rsv-guest-link]');
    if (guestLink) {
      var guestTarget = formUrl + (formUrl.indexOf('?') === -1 ? '?' : '&') + 'guest=1';
      guestLink.href = withPreviewThemeId(guestTarget);
    }

    var saveLink = cta.querySelector('[data-rsv-save-link]');
    if (saveLink) {
      saveLink.href = formTarget;
    }
  });

});
